import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../../ns_libs/nsAxios';
import API_ENDPOINTS, { QUERY_KEYS } from '../../../services/urls';
import { ISubprojectStage } from '../types';

export const getSubprojectsStages = async () => {
    const response = await axiosInstance.get(API_ENDPOINTS.SUBPROJECT_STAGES);
    return response.data;
};

export const useGetSubprojectsStages = () => useQuery<ISubprojectStage[], Error>({
    queryKey: [QUERY_KEYS.SUBPROJECT_STAGES],
    queryFn: async () => getSubprojectsStages(),
    staleTime: Infinity,
});
